<template>
  <div class="modal micromodal-slide" aria-hidden="true" id="modal-2" v-bind:class="{ 'is-open': cartIsOpen }">
    <div class="modal__overlay" v-on:click="close()" tabindex="-1" data-micromodal-close></div>
    <div class="modal_item modal_cart cart_detail">
      <button v-on:click="close()" class="close">
        <span class="close_image"><img src="../../assets/images/close.png" alt=""></span>
      </button>


      <div class="scroll" ref="modal__content">
        <div class="cart_wrap">
          <p class="cart_title ab">カートの合計</p>
          <div class="price_wrap">
            <p class="price_sum rm"><span class="yen ab">￥</span>{{ totalPrice }}</p>
            <p class="cart_point rm"><span class="point ab">ポイント：</span>{{ calcTotalPoint() }}<span class="cart_pt ab">pt</span></p>
          </div>
          <!-- <pre>{{ this.nselectionOrderList }}</pre> -->
        </div>
        <div class="tab_contents">
          <div class="bc_user">

            <div class="" v-if="this.nselectionOrderList.length != 0">
              <div class="select_item" v-for="(cartItem, n) in this.nselectionOrderList" :key="n">
                <div class="image_wrap">
                  <ProductImage :productId="cartItem.productId" :genreId="cartItem.purchaseOrderItemList[0].genreId" />
                  <p class="select_item--title ab">{{ cartItem.productName }}</p>
                  <button class="delete btn_delete btn_mini" @click="deleteItem(cartItem.purchaseOrderItemList, cartItem.productId, cartItem.purchaseOrderItemList[0].genreId)">削除</button>
                </div>

                <div class="select_contents">
                  <BuyTotalMonth :productId="cartItem.productId" :genreId="cartItem.purchaseOrderItemList[0].genreId" />
                  <div v-if="isSelectableChildFund(cartItem.productId, cartItem.purchaseOrderItemList[0].genreId)" class="kodomo_wrap">
                    <input class="kodomo_check" type="checkbox" v-bind:id="'kodomo' + n" name="checkbox01" @change="updateOrderitem(cartItem.productId, cartItem.purchaseOrderItemList[0].genreId)" :checked="cartItem.purchaseOrderItemList[0].childFund">
                    <label v-bind:for="'kodomo' + n" class="checkbox01 ab">こども基金を支援する</label>
                  </div>
                  <div class="select_price" v-bind:class="{ mt20: !isSelectableChildFund(cartItem.productId, cartItem.purchaseOrderItemList[0].genreId) }">
                    <p class="item_price rm"><span class="yen ab">￥</span>{{ calcItemTotalPrice(cartItem.purchaseOrderItemList) }}</p>
                    <p  class="item_point rm" ><span class="point_text ab">ポイント：</span>{{ calcItemTotalPoint(cartItem.purchaseOrderItemList, cartItem.productId, cartItem.purchaseOrderItemList[0].genreId) }}<span class="point ab">pt</span></p>
                  </div>
                </div>
              </div>

              <!-- <div class="select_item select_sum">
                <div class="select_price">
                  <p class="item_price rm"><span class="subtotal ab">小計：</span><span class="yen ab">￥</span>{{ calcTotalPrice() }}</p>
                  <p class="item_point rm"><span class="point_text ab">このご注文での獲得ポイント：</span>{{ totalPoint }}<span class="point ab">pt</span></p>
                </div>
              </div> -->


            </div>

            <div class="cart_none none ab pt16 pl16 pr16" v-else>カートに商品はありません</div>
            <!-- <button class="btn_blue" v-on:click="close()">閉じる</button> -->
          </div>
        </div>
      </div>



    </div>
  </div>
</template>

<script>
import scrollPosition from '@/model/scrollPosition';
import Config from '@/config/config';
import { mapGetters } from 'vuex';
import ProductImage from '@/components/n-selection/parts/ProductImage'
import BuyTotalMonth from '@/components/n-selection/parts/BuyTotalMonth'
import ProductFunction from '@/model/n-selection/selectProducts'


export default {
  components: {
    ProductImage,
    BuyTotalMonth
  },
  data () {
    return {
    };
  },
  methods: {
    close () {
      this.$refs.modal__content.scrollTop = 0;
      scrollPosition.close();
      this.$store.commit('nselection/setCartIsOpen', false);
    },
    deleteItem (purchaseOrderItemList, productId, genreId) {
      const index = this.nselectionOrderList.findIndex((product) => product.productId == productId);
      console.log(index);
      this.$store.dispatch('nselection/deleteProduct', { deleteIndex: index });
      this.$store.dispatch('nselection/calcCartCount', { status: 'delete' });
      // this.$store.dispatch('nselection/calcTotalPoint', { point: - this.calcItemTotalPoint(purchaseOrderItemList, productId, genreId), reset: false });
      // this.calcTotalPoint();
    },
    calcTotalPrice() {
      let totalPrice = 0;
      for (let i = 0; i < this.nselectionOrderList.length; i++) {
        totalPrice = totalPrice + this.nselectionOrderList[i].totalPrice;
      }
      this.$store.commit('nselection/setTotalPrice', totalPrice);
    },
    calcItemTotalPrice(purchaseOrderItemList) {
      let price = 0
      for (let i = 0; i < purchaseOrderItemList.length; i++) {
        price = price + purchaseOrderItemList[i].price * purchaseOrderItemList[i].orderCount;
      }

      return price;
    },
    calcItemTotalPoint(purchaseOrderItemList, productId, genreId) {
      let point = 0
      const indexList = ProductFunction.productIndex(this.productsList, productId, genreId);
      if(indexList == undefined) return 0;
      let productPoint = this.productsList[indexList.genreIdIndex].itemList[indexList.productIdIndex].product.point;
      for (let i = 0; i < purchaseOrderItemList.length; i++) {
        point = point + productPoint * purchaseOrderItemList[i].orderCount;
      }

      return point;
    },
    isSelectableChildFund(productId, genreId) {
      const indexList = ProductFunction.productIndex(this.productsList, productId, genreId);
      if(indexList == undefined) return false;
      return this.productsList[indexList.genreIdIndex].itemList[indexList.productIdIndex].product.selectableChildFund;
    },
    updateOrderitem(productId, genreId) {
      const index = this.nselectionOrderList.findIndex(({productId}) => productId === productId);

      const data = ProductFunction.updatePurchaseOrderItemList(this.nselectionOrderList[index], this.currentMonth, this.nselectionOrderList[index].purchaseOrderItemList[0].orderCount, this.nselectionOrderList[index].purchaseOrderItemList[1].orderCount);
      this.$store.commit('nselection/setNselectionOrderList', data);
    },
    initialized() {
      console.log('initialized');
      this.$store.dispatch('nselection/calcTotalPoint', { point: 0, reset: true });
    },
    calcTotalPoint() {
      let point = 0;
      for (var i = 0; i < this.nselectionOrderList.length; i++) {
        const indexList = ProductFunction.productIndex(this.productsList, this.nselectionOrderList[i].productId, this.nselectionOrderList[i].purchaseOrderItemList[0].genreId);
        if(indexList == undefined) continue;
        let productPoint = this.productsList[indexList.genreIdIndex].itemList[indexList.productIdIndex].product.point;
        for (var a = 0; a < this.nselectionOrderList[i].purchaseOrderItemList.length; a++) {
          point = point + productPoint * this.nselectionOrderList[i].purchaseOrderItemList[a].orderCount;
        }
      }
      this.$store.dispatch('nselection/calcTotalPoint', { point: point, reset: false });
      return this.totalPoint;
    }
  },
  computed: mapGetters(
    'nselection', ['productsList', 'nselectionOrderList', 'cartIsOpen', 'totalPoint', 'totalPrice'],
  ),
  watch: {
    nselectionOrderList() {
      this.calcTotalPrice();
      this.calcTotalPoint();
    }
  },
  async created() {
    await this.initialized();
    this.calcTotalPoint();

  }
};
</script>

<style lang="css" scoped>
/* カートに商品がない場合 */
.cart_none {
  padding: 15px;
}
/* カート中身 */
.detail_wrap {
  overflow-y: inherit;
  padding-top: 74px;
}

.cart_wrap {
  border-bottom: 1px solid #c9c9c9;
  padding: 0 16px 10px;
}

.cart_title {
  font-size: 18px;
}

.price_wrap {
  color: #009FA9;
  text-align: right;
}

.price_sum {
  font-size: 28px;
}

.yen {
  font-size: 22px;
}

.cart_point {
  font-size: 18px;
}

.point {
  font-size: 14px;
}

.cart_pt {
  font-size: 14px;
}

.cart_tab input {
  display: none;
}

.cart_tab {
  border-bottom: 1px solid  #aaa;
  display: flex;
  justify-content: space-between;
  margin-top: 30px;
}

.cart_tab .tab {
  border: solid #AAAAAA;
  border-width: 1px 1px 0;
  border-radius: 12px 12px 0 0;
  background-color: #f4f4f4;
  color: #A3A3A3;
  font-size: 20px;
  padding: 9px 0 8px 16px;
  width: 49.9%;
}

.cart_tab .tab.isActive {
  background-color: #fff;
  color: #5a5a5a;
}

.other_bc {
  border-bottom: 1px solid  #c9c9c9;
  display: flex;
  justify-content: space-between;
  padding: 37px 16px 25px;
}
.bc_number {
  font-size: 20px;
}

.other_number--detail {
  align-items: flex-end;
  display: flex;
  flex-direction: column;
}
.other_bc--price {
  font-size: 26px;
}
.yen {
  font-size: 20px;
}
.btn_mini {
  margin: 16px 0 0;
}

.select_item {
  border-bottom: 1px solid  #c9c9c9;
  display: flex;
  justify-content: space-between;
  padding: 30px 15px 25px 30px;
}
.image_wrap {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  text-align: center;
  width: 33%;
}

.select_image {
  /* margin: auto;
  width: 73%; */
}

.month_item {
  display: flex;
  margin-top: 16px;
}



.before_border::before {
  border-left: 4px solid #4FCCD4;
  bottom: 0;
  content: '';
  margin: auto;
  position: absolute;
  top: 0;
}


.count_wrap {
  align-items: center;
  display: flex;
  margin-left: 8px;

}

.select_item--title {
  font-size: 12px;
  margin-top: 12px;
}
.btn_delete {
  margin: 21px auto 0;
}

.select_contents {
  width: 59%;
}

.manth_wrap {
  margin-top: 0;
}


.month {
  border-bottom: 1px solid #c9c9c9;
  font-size: 16px;
  letter-spacing: 1px;
  padding-left: 8px;
  position: relative;
  width: 40%;
}

.month::before {
  bottom: 2px;
  left: 0;
  width: 4px;
}

.month_number {
  font-size: 22px;
}

.count_wrap {
  align-items: flex-end;
  width: 60%;
}

.count {
  font-size: 12px;
}

.select_count {
  border-bottom: 1px solid #5a5a5a;
  margin-left: 5px;
  /* width: 70%; */
  width: 63%;
}
.select_count:after {
  bottom: 6px;
  right: 0;
}
.select_count select {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  font-size: 20px;
  padding-left: 7px;
  /* padding-left: 5px; */
  /* padding-right: 10px; */
  /* text-align: center; */
  width: 100%;
}

.checkbox01 {
  display: flex;
  font-size: 14px;
  justify-content: flex-end;
  margin-top: 20px;
  padding: 5px 0 5px 30px;
}

.checkbox01::before {
  left: 0;
}

.checkbox01::after {
  left: 5px;
}

.select_price {
  align-items: flex-end;
  display: flex;
  flex-direction: column;
}

.item_price {
  font-size: 26px;
}

.yen {
  font-size: 20px;
}

.item_point {
  font-size: 16px;
}

.point_text {
  font-size: 12px;
}

.select_sum {
  display: block;
  margin-top: 0;
  padding: 24px 15px;
}

.select_sum .item_price {
  margin-top: 0;
}

.select_sum .subtotal {
  font-size: 14px;
}

.btn_blue {
  margin-top: 32px;
}

.bg.open {
  top: 0;
}

.detail_wrap {
  max-height: 100%;
}

.buy_text {
  width: 70%;
}
.input_number {
  border: none;
  border-bottom: 1px solid #000;
  display: block;
  font-size: 26px;
  padding-right: 5px;
  text-align: right;
  width: 100%;
}

.no_month {
  justify-content: flex-end;
}
.no_month .month {
  display: none;

}
.no_month .count_wrap {
  margin-left: 0;
  width: 65%;
}
.no_month .count {
  width: 30%;
}
.no_month .select_count {
  margin-right: 0;
  margin-left: 0;
  width: 70%;
}
</style>



// WEBPACK FOOTER //
// src/components/n-selection/Cart.vue